module.exports = "<div class=\"map-button-vertical-layout\">\n</div>";